import axios from 'axios'

export interface ProductAreaType {
  id: string
  name: string
  productUpdateCount: number
}

const productAreaService = {
  async productAreasList () {
    let productAreas: ProductAreaType[] = []
    let page = 1
    while (page <= 10) {
      let data
      try {
        data = (await axios.get('/settings/product-areas/api', {
          params: {
            pageSize: 100,
            page: page
          }
        })).data
      } catch (err) {
        return productAreas
      }
      if (!data) return productAreas

      productAreas = productAreas.concat(data.result)

      if (data.result.length < 100) return productAreas
      page += 1
    }
    return productAreas
  }
}

export default productAreaService
